module.exports = __webpack_public_path__ + "img/faq-icon.19eed56d.png";